import React, { useEffect } from 'react';
import { generalStore, playlistStore } from '../../store';
import PlaylistContent from '../../components/playlistContent/PlaylistContent';
import Loader from '../../components/loader/Loader';
import { useParams } from 'react-router';
import { useModuleTypesStore } from '../../store';
import type { Playlist } from '../../api/types';

const PlaylistDetailView = () => {
    const { id: playlistId } = useParams<{ id: string }>();
    const { getPlaylist, selectedPlaylist } = playlistStore();
    const { moduleTypes } = useModuleTypesStore();
    const { setLoading, loading } =  generalStore();

    useEffect(() => {
        if (playlistId) {
            getPlaylist(playlistId);
        }
        setLoading(false);
    }, [playlistId]);

    if (!playlistId || selectedPlaylist.loading || loading || !selectedPlaylist['@id']) {
        return <Loader loading={true} />;
    }

    const playlist = selectedPlaylist as Playlist;

    return (
        <div className="b-playlistContent-view">
            <PlaylistContent
                playlistId={playlistId}
                playlist={playlist}
                moduleTypes={moduleTypes}
            />
        </div>
    );
};

export { PlaylistDetailView };

export default PlaylistDetailView;
